import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'lib-mapposition',
  standalone: true,
  templateUrl: './mapposition.component.html',
  styleUrls: ['./mapposition.component.scss']
})
export class MappositionComponent {
  @Input() public zoom = 5;
@Input() public lat = 38.464622;
@Input() public lng = -101.624108;
  @Output() notify = new EventEmitter();

}